import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

interface AnnouncerModeState {
  active: boolean;
  eventId: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class AnnouncerModeService {
  private readonly STORAGE_KEY = 'announcerMode';
  private _localStorage = inject(LocalStorageService);
  private _isActive: WritableSignal<boolean> = signal<boolean>(false);
  private _eventId: WritableSignal<string | null> = signal<string | null>(null);

  isActive = this._isActive.asReadonly();
  eventId = this._eventId.asReadonly();

  constructor() {
    this._loadFromStorage();
  }

  enterAnnouncerMode(eventId: string): void {
    this._isActive.set(true);
    this._eventId.set(eventId);
    this._saveToStorage();
  }

  exitAnnouncerMode(): void {
    this._isActive.set(false);
    this._eventId.set(null);
    this._clearStorage();
  }

  isInAnnouncerModeForEvent(eventId: string): boolean {
    return this._isActive() && this._eventId() === eventId;
  }

  private _loadFromStorage(): void {
    const state = this._localStorage.get<AnnouncerModeState>(this.STORAGE_KEY);
    if (state) {
      this._isActive.set(state.active);
      this._eventId.set(state.eventId);
    }
  }

  private _saveToStorage(): void {
    const state: AnnouncerModeState = {
      active: this._isActive(),
      eventId: this._eventId(),
    };
    this._localStorage.set(this.STORAGE_KEY, state);
  }

  private _clearStorage(): void {
    this._localStorage.remove(this.STORAGE_KEY);
  }
}
